import React from "react";
import { NavLink } from "react-router-dom";
import PrivacyHeaderImage from "../../assets/images/login/our-data.png";
const BannerSection = () => {
  return (
    <>
      <section className="topPageBanner _border-bottom">
        <div className="max-container">
          <div className="padd-90">
            <div className="grid-auto-fit align-items-center">
              <div>
                <h1 className="heading39px roboto-boldroboto-regular mb20 text-color-131415">
                  <span className="roboto-bold">OUR</span> DATA
                </h1>

                <p className="roboto-regular heading16px mb30 text-color-131415">
                  "Good data quality isn't just a nice-to-have, it's a business
                  necessity! So let's make sure your data is accurate and as
                  compliant as a rule-following penguin wearing a suit."
                </p>
                <NavLink
                  to={"/contact-us"}
                  className="common-btn-class main-btn-primary roboto-regular"
                >
                  Contact us
                </NavLink>
              </div>
              <div className="text-center">
                <img
                  src={PrivacyHeaderImage}
                  className="img-responsive position-relative"
                  alt="Double Your Qualified Leads"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default BannerSection;
